export const in_prod = !(window.location.host.includes("localhost") || window.location.host.includes("127.0.0.1") || window.location.host.includes("3000"));
export const force_login_mode = true;
export const enable_client_log = true;
export const DEFAULT_CACHE_TIME = 200;

// to change
// export const PROD_BACKEND_IP = in_prod ? `apimydimension.org` : `${window.location.host}`

export const PROD_BACKEND_IP = in_prod ? `apimydimension.org` : `${window.location.hostname}`
